<mat-card>
  <div appInfoEntry [infoEntry]="infoEntry"></div>
</mat-card>
